export const en = {
  auth: {
    emailPasswordRequired: "Please enter your email and password.",
    rateLimited: "Too many failed login attempts. Please try again later.",
    invalidCredentials: "Invalid username or password",
    unexpectedError: "An unexpected error occurred. Please try again.",
  },
  password: {
    doesNotMatch: "Passwords do not match",
    doesNotMeetRequirements: "Password does not meet all requirements",
    tooShort: "Password must be at least 8 characters",
  },
} as const;
